import type { RouteObject } from "react-router";
import { SpecimenPage } from "../shared/specimen/SpecimenPage";
import { AppShell } from "./AppShell";
import { NotFoundPage } from "./NotFoundPage";
import { PortalEntry, PortalLoginEntry } from "./PortalEntry";
import { RouteError } from "./RouteError";
import { ScreenRoute } from "./ScreenRoute";
import { screens } from "./screens";
import { LoginPage } from "./session/LoginPage";
import { SessionGate } from "./session/SessionGate";
import { PresentRoute } from "../features/presentations/PresentRoute";

/**
 * Sign-in sits outside the shell; every product screen needs a session. The developer specimen needs none, so it
 * renders without the API.
 */
export const routes: RouteObject[] = [
  { path: "/login", element: <LoginPage />, errorElement: <RouteError /> },
  // The external tester's portal (`/portal/*`): never inside AppShell, so nothing of the internal app paints for a tester.
  { path: "/portal/login", element: <PortalLoginEntry />, errorElement: <RouteError /> },
  { path: "/portal/*", element: <PortalEntry />, errorElement: <RouteError /> },
  { path: "/_dev/specimen", element: <SpecimenPage /> },
  // Presentations (PRESENT-SPEC-20261028 §7.2, §7.3; Features__Presentations): the controller and the audience screen are chromeless.
  {
    path: "/present",
    element: (
      <SessionGate>
        <PresentRoute screen="audience" />
      </SessionGate>
    ),
    errorElement: <RouteError />,
  },
  {
    path: "/p/:projectKey/presentations/:id/present/:sessionId",
    element: (
      <SessionGate>
        <PresentRoute screen="controller" />
      </SessionGate>
    ),
    errorElement: <RouteError />,
  },
  {
    path: "/",
    element: (
      <SessionGate>
        <AppShell />
      </SessionGate>
    ),
    // Batch 13: never the router's raw error screen; a stale screen file after a deploy reloads once (staleChunk.ts).
    errorElement: <RouteError />,
    children: [
      ...screens.map((screen): RouteObject =>
        screen.path === "/"
          ? { index: true, element: <ScreenRoute screen={screen} /> }
          : { path: screen.path.slice(1), element: <ScreenRoute screen={screen} /> },
      ),
      { path: "*", element: <NotFoundPage /> },
    ],
  },
];
